<p-toast style="z-index: 1000000 !important;"></p-toast>
@if (title) {
  <div class="d-flex align-items-center justify-content-between mb-2">
    <h5 class="mb-0" style="font-weight:600;">{{ title }}</h5>
    @if (showCreateButton) {
      <button pButton pRipple class="p-button p-button-sm" (click)="addTask(1)">+ New Task</button>
    }
  </div>
}
<div>
  <!-- <div class="col-2" *ngIf="showFilter">
  <div class="mt-2">
    <label class="fs-6 mb-1 fw-normal">People :</label>
    <div class="mt-1">
      <p-multiSelect #aa [options]="usersSearch" [displaySelectedLabel]="true" [showClear]="true"
        (onClear)="pt.filter('', 'assignedToUserVO.userId', 'in')" optionLabel="fullName" dropdownIcon="fa fa-caret-down"
        optionValue="userId" appendTo="body"
      (onChange)="pt.filter($event.value, 'assignedToUserVO.userId', 'in')"></p-multiSelect>
    </div>
  </div>

  <div class="mt-2">
    <label class="fs-6 mt-2 mb-1 fw-normal">Categories :</label>
    <div class="mt-1">
      <app-task-folder-nav (eventTagSelect)="onTagSelect($event)"></app-task-folder-nav>
    </div>
  </div>
</div> -->
<div>
  <p-treeTable #pt class="kbmadmintable"
    [value]="tableData" [paginator]="true" dataKey="taskId" selectionMode="single"
    [loading]="loading"
    [columns]="displayColumns" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="taskId"
    (onNodeExpand)="onNodeExpand($event)" [rows]="25" [rowsPerPageOptions]="[25, 100, 200]"
    showCurrentPageReport="true" styleClass="p-datatable-striped"
    currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
    [totalRecords]="recordTotal" [tableStyle]="{'min-width':'50rem'}" [resizableColumns]="true" [autoLayout]="true"
    [scrollable]="true" [ngStyle]="{ width: 'auto' }" [(contextMenuSelection)]="selectedNode" [contextMenu]="gf"
    (onEditInit)="onCellEditInit($event)" (onEditComplete)="onCellEditComplete($event)"
    (onEditCancel)="onCellEditCancel()" [filters]="filters">
    <ng-template pTemplate="caption">
      <!-- <i class="fa fa-search" style="margin:4px 4px 0 0;" *ngIf="showFilter"></i> -->
      <!-- <div class="d-block text-end ctm_admin" *ngIf="showFilter">
      <div class="row">
        <div class="col-lg-8 px-1">
          <div class="bg-light-blue">
            <div>
              <div class="row g-3 p-2">
                <div class="col-lg-3 col-md-6" *ngFor="let item of getTaskSummaryItems()">
                  <div style="white-space: nowrap;">
                    <span style="float: left">{{item.label}}</span>
                    <a (click)="loadWithParam(item.param)" class="link-primary ms-2">{{item.value}}</a>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <div style="padding: 5px;">
                  <span *ngIf="loadingSummary">
                    <p-progressSpinner [style]="{ width: '20px', height: '20px' }" [strokeWidth]="5"
                    ariaLabel="Loading"></p-progressSpinner>
                  </span>
                  <span *ngIf="!loadingSummary" class="link-primary text-decoration-underline fs-12px cursor-pointer"
                    (click)="reloadSummaryCount()">
                    Refresh Summary
                  </span>
                </div>
                <div style="padding: 5px;">
                  <span class="link-primary text-decoration-underline fs-12px cursor-pointer" (click)="reloadPage()">
                    Clear Filters
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="ctm_btns mb-2"><p-selectButton class="ctm_btn" [options]="priorityButtons"
          (onChange)="loadLazyForPriority($event)" optionLabel="label"></p-selectButton>
        </div>
      </div>
      <div class="col-lg-4 px-1">
        <div class="d-flex justify-content-between">
          <div>
            <app-import-export importEnabled="false" [dataRetrived]="taskList" (exportDataSelected)="exportSelected($event)"
            [columns]="columns" [importDisabled]="true"></app-import-export>
          </div>
          <div>
            <button *ngIf="!outlineNewButton" pButton pRipple class="p-button-outlined"
            style="padding: 0.643rem 0.75rem !important;" (click)="addTask(1)">New Task +</button>
            <button *ngIf="outlineNewButton" pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
            (click)="addTask(1)">New Task +</button>
            <button *ngIf="outlineNewButton" pButton pRipple class="p-button"
              style="padding: 0.643rem 0.75rem !important; margin-left:10px;" (click)="addQuickTask(1)">Quick
            Add</button>

            <p-dialog header="QUICK ADD" [modal]="true" [(visible)]="visible" [style]="{ width: '25rem' }">
              <div class="text-start d-flex flex-column gap-3">
                <input type="text" placeholder="Title" class="p-inputtext p-component p-element w-100">
                <div class="description d-flex flex-column gap-1">
                  <label for="">Description</label>
                  <input type="text" placeholder="Description" class="p-inputtext p-component p-element">
                </div>
                <div class="team-input-wrapper d-flex flex-column gap-1">
                  <label for="">Assigned to Team:</label>
                  <input type="text" placeholder="" class="p-inputtext p-component p-element">
                </div>
                <div class="person-input-wrapper d-flex flex-column gap-1">
                  <label for="">Assigned to Person:</label>
                  <input type="text" placeholder="" class="p-inputtext p-component p-element">
                </div>
                <div class="btn-custom">
                  <button *ngIf="outlineNewButton" pButton pRipple class="p-button justify-content-center"
                  (click)="visible = false">Save</button>
                </div>
              </div>
            </p-dialog>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!-- <div class="row align-items-center m-2 bg-light rounded">
  <div class="col-lg-8 col-md-12 mb-2 mb-lg-0">
    <div class="d-flex align-items-center flex-wrap gap-2">
      <label class="mb-0 me-2" style="font-weight: 600;">Active Filters:</label>
      <p-chips *ngIf="activefilter.length > 0" [(ngModel)]="activefilter" label="" (onRemove)="removedFilter($event)"
        [style]="{'min-width': '200px'}">
        <ng-template let-item pTemplate="item">
          <span [innerHTML]="item.displayName"></span>
        </ng-template>
      </p-chips>
      <span *ngIf="activefilter.length === 0" class="text-muted small">No active filters</span>
    </div>
  </div>
  <div class="col-lg-4 col-md-12">
    <div class="d-flex align-items-center justify-content-lg-end justify-content-md-start gap-2">
      <label class="mb-0" style="font-weight: 600;">Include Status Report:</label>
      <p-inputSwitch [(ngModel)]="loadStatusEnabled"
      (onChange)="loadLazy(lazyLoadEvent)"></p-inputSwitch>
    </div>
  </div>
</div> -->
</ng-template>
@if (showFilter) {
  <ng-template pTemplate="header">
    <tr>
      <th class="task-col-id task-list-th">ID</th>
      @for (col of getDisplayColumns(); track col) {
        <th class="text-nowrap task-list-th" [ttSortableColumn]="col.field"
          [ngClass]="{'task-col-due': col.field === 'dateDue', 'task-col-name': col.field === 'name', 'task-col-assigned': col.field === 'assignedToUserVO.lastName', 'task-col-priority': col.field === 'priority', 'task-col-author': col.field === 'createdByUserVO.lastName', 'task-col-requested': col.field === 'requestedByUserVO.lastName', 'task-col-status': col.field === 'status', 'task-col-followup': col.field === 'dateToFollowup', 'task-col-created': col.field === 'dateCreated', 'task-col-completed': col.field === 'dateCompleted'}">
          {{ col.header }}<p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon>
        </th>
      }
      @if (loadStatusEnabled) {
        <th class="task-col-status-update task-list-th">status update</th>
      }
    </tr>
    <tr>
      <th class="task-col-id"><input pInputText type="text"
      (input)="pt.filter($event.target.value, 'taskId', 'in')"></th>
      <th class="task-col-due"></th>
      <th class="task-col-name"><input pInputText type="text"
      [(ngModel)]="selectedFilterName" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
      <th class="task-col-assigned">
        <app-user-search [forSearchBar]="true"
          (onUserSelected)="pt.filter($event.userId, 'assignedToUserVO.userId', 'in')"
          (onUserClearedEvent)="assignedSearchToUser=null;pt.filter(null, 'assignedToUserVO.userId', 'in');"
        [selectedUser]="assignedSearchToUser" [showCreateUser]="false"></app-user-search>
      </th>
      <th class="task-col-priority">
        <p-multiSelect class="multiselectdropdown" dropdownIcon="fa fa-caret-down" [options]="priorities" displaySelectedLabel optionLabel="name"
          optionValue="value" appendTo="body" [(ngModel)]="selectedPriorityFilter"
          (onChange)="pt.filter($event.value, 'priority', 'in');" optionLabel="name" display="chip"
        [displaySelectedLabel]="true"></p-multiSelect>
      </th>
      <th class="task-col-author">
        <app-user-search [forSearchBar]="true"
          (onUserSelected)="pt.filter($event.userId, 'createdByUserVO.userId', 'in')"
          (onUserClearedEvent)="createdBySearchToUser=null;pt.filter(null, 'createdByUserVO.userId', 'in')"
        [selectedUser]="createdBySearchToUser" [showCreateUser]="false"></app-user-search>
      </th>
      <th class="task-col-requested">
        <app-user-search [forSearchBar]="true"
          (onUserSelected)="pt.filter($event.userId, 'requestedByUserVO.userId', 'in')"
          (onUserClearedEvent)="requestedBySearchToUser=null;pt.filter(null, 'requestedByUserVO.userId', 'in')"
        [selectedUser]="requestedBySearchToUser" [showCreateUser]="false"></app-user-search>
      </th>
      <th class="task-col-status">
        <p-multiSelect class="multiselectdropdown" dropdownIcon="fa fa-caret-down" [options]="statuses" displaySelectedLabel optionLabel="name"
          optionValue="value" appendTo="body" [(ngModel)]="selectedStatusFilter"
          (onChange)="pt.filter($event.value, 'status', 'in');" optionLabel="name" display="chip"
        [displaySelectedLabel]="true"></p-multiSelect>
      </th>
      <th class="task-col-followup"></th>
      <th class="task-col-created"></th>
      <th class="task-col-completed"></th>
      @if (loadStatusEnabled) {
        <th class="task-col-status-update">
          <p-calendar [(ngModel)]="statusUpdateRange" appendTo="body" selectionMode="range"
          placeholder="Status Changed in Date" (onClose)="loadLazy(lazyLoadEvent)"></p-calendar>
        </th>
      }
    </tr>
  </ng-template>
}

<ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns" let-expanded="expanded">
  <tr [ttContextMenuRow]="rowNode" [ttRow]="rowNode"
    [class.task-list-row-child]="rowData.ischild">
    <td class="task-col-id task-list-td">
      <span class="task-list-id-cell">
        <span (click)="onOpenFormEdit(rowData)" class="task-list-cell-link">{{ rowData?.taskId }}</span>
        <span (click)="openCm($event, gf, rowNode)"><i class="pi pi-align-justify" aria-hidden="true"></i></span>
        <span>
          @if (getNumnerOfTasks(rowData)>0) {
            <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
          }
          @if (getNumnerOfTasks(rowData)>0) {
            <span>{{ getNumnerOfTasks(rowData) }}</span>
          }
        </span>
      </span>
    </td>
    @if (isColumnVisible('dateDue')) {
      <td class="task-col-due task-list-td" (click)="onOpenFormEdit(rowData)"
        [style.background-color]="getColorForDue(rowData)" [style.color]="'white'"><span>{{ rowData?.dateDue | date }}</span></td>
      }
      @if (isColumnVisible('name')) {
        <td class="task-col-name task-list-td task-list-cell-link" (click)="onOpenFormEdit(rowData)">{{ rowData?.name }}</td>
      }
      @if (isColumnVisible('assignedToUserVO.lastName')) {
        <td class="task-col-assigned task-list-td"
          (click)="pt.filter(rowData?.assignedTo?.userId, 'assignedToUserVO.userId', 'in'); assignedSearchToUser=rowData?.assignedTo">
          <span class="task-list-cell-link">{{ fullName(rowData?.assignedTo) }}</span></td>
        }
        @if (isColumnVisible('priority')) {
          <td class="task-col-priority task-list-td">
            <p-dropdown dropdownIcon="fa fa-caret-down" appendTo="body" [options]="priorities" [(ngModel)]="rowData.priority" optionLabel="name"
              optionValue="value" (onChange)="changeInplaceDataPriority($event, rowData)">
            </p-dropdown>
          </td>
        }
        @if (isColumnVisible('createdByUserVO.lastName')) {
          <td class="task-col-author task-list-td"
            (click)="pt.filter(rowData?.createdBy?.userId, 'createdByUserVO.userId', 'in'); createdBySearchToUser=rowData?.createdBy">
            <span class="task-list-cell-link">{{ fullName(rowData?.createdBy) }}</span></td>
          }
          @if (isColumnVisible('requestedByUserVO.lastName')) {
            <td class="task-col-requested task-list-td"
              (click)="pt.filter(rowData?.requestedBy?.userId, 'requestedByUserVO.userId', 'in'); requestedBySearchToUser=rowData?.requestedBy">
              <span class="task-list-cell-link">{{ fullName(rowData?.requestedBy) }}</span></td>
            }
            @if (isColumnVisible('status')) {
              <td class="task-col-status task-list-td">
                <p-dropdown [style]="{'width': '100%'}" dropdownIcon="fa fa-caret-down" appendTo="body" [options]="statuses" [(ngModel)]="rowData.status"
                  optionLabel="name" optionValue="value" (onChange)="changeInplaceData($event, rowData)">
                </p-dropdown>
              </td>
            }
            @if (isColumnVisible('dateToFollowup')) {
              <td class="task-col-followup task-list-td" (click)="onOpenFormEdit(rowData)">{{ rowData?.dateToFollowup | date }}</td>
            }
            @if (isColumnVisible('dateCreated')) {
              <td class="task-col-created task-list-td" (click)="onOpenFormEdit(rowData)">
                {{ rowData?.dateCreated | date }}&nbsp;<span class="task-list-cell-muted">{{ daysFromTodayAbs(rowData?.dateCreated) }}d</span></td>
              }
              @if (isColumnVisible('dateCompleted')) {
                <td class="task-col-completed task-list-td" (click)="onOpenFormEdit(rowData)">{{ rowData?.dateCompleted | date }}</td>
              }
              @if (loadStatusEnabled) {
                <td class="task-col-status-update task-list-td">
                  @for (note of rowData?.noteList; track note) {
                    <div>
                      <span><b>{{ note?.createdBy?.firstName }} on {{ note?.lastUpdate | date:'medium' }}</b></span>
                      <br>
                        <span [innerHTML]="note?.description"></span>
                      </div>
                    }
                  </td>
                }
              </tr>
            </ng-template>
          </p-treeTable>
          <p-contextMenu #gf appendTo="body" [model]="items"></p-contextMenu>
        </div>
      </div>

      <p-dialog header="Summary" [(visible)]="showOpenSummary" [style]="{width: '30vw'}">
        @if (taskApiData) {
          <app-task-summary [task]="taskApiData"></app-task-summary>
        }
      </p-dialog>